import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface RouteChangeListenerProps {
  children: React.ReactNode | React.ReactNode[];
}

/**
 * The <RouteChangeListener /> component acts as a wrapper around the application
 *
 * We use this component to trigger events when the current route changes
 * e.g. analytics events, setting focus for screen readers, etc
 */
const RouteChangeListener: React.FC<RouteChangeListenerProps> = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    document.querySelector<HTMLElement>('h1')?.setAttribute('tabIndex', '-1');
    document.querySelector<HTMLElement>('h1')?.focus();
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <>{children}</>;
};

export default RouteChangeListener;
